import { Observable } from "rxjs";
import { Store } from "@karma-games/angular-devkit/src/lib/extended-store";
import { ERoundState, IRound, IRoundBet, IRoundGetStateData } from "../interfaces";
import {
    selectRoundAllData,
    selectRoundBets,
    selectRoundCurrentState,
    selectRoundId, selectRoundInitialState,
    selectRoundMultiplier, selectTotalBetsCount
} from "./round.selectors";

declare module "@ngrx/store/src/store" {
    interface Store<T> {
        subscribeRoundBets(): Observable<IRoundBet[]>;
        subscribeTotalBetsCount(): Observable<number>;
        subscribeRoundMultiplier(): Observable<number>;
        getCurrentRoundId(): string | undefined;
        subscribeRoundCurrentState(): Observable<ERoundState>;
        subscribeRound(): Observable<IRound>;
        subscribeRoundInitialState(): Observable<IRoundGetStateData | undefined>;
    }
}

function subscribeRoundBets(this: Store): Observable<IRoundBet[]> {
    return this.select(selectRoundBets);
}

function subscribeTotalBetsCount(this: Store): Observable<number> {
    return this.select(selectTotalBetsCount);
}

function subscribeRoundMultiplier(this: Store): Observable<number> {
    return this.select(selectRoundMultiplier);
}

function getCurrentRoundId(this: Store): string | undefined {
    return this.selectSync(selectRoundId);
}

function subscribeRoundInitialState(this: Store): Observable<IRoundGetStateData | undefined> {
    return this.select(selectRoundInitialState);
}

function subscribeRoundCurrentState(this: Store): Observable<ERoundState> {
    return this.select(selectRoundCurrentState);
}

function subscribeRound(this: Store): Observable<IRound> {
    return this.select(selectRoundAllData);
}

Store.prototype.subscribeRoundBets = subscribeRoundBets;
Store.prototype.subscribeTotalBetsCount = subscribeTotalBetsCount;
Store.prototype.subscribeRoundMultiplier = subscribeRoundMultiplier;
Store.prototype.getCurrentRoundId = getCurrentRoundId;
Store.prototype.subscribeRoundCurrentState = subscribeRoundCurrentState;
Store.prototype.subscribeRound = subscribeRound;
Store.prototype.subscribeRoundInitialState = subscribeRoundInitialState;
